import { Link } from 'react-router-dom';
import css from './cookies-policy.module.scss';
import BackButton from 'src/components/buttons/back-button';

export default function PersonalDataPolicy() {
  return (
    <main className={css.container}>
      <div className={css.headerWrapper}>
        <BackButton backLink='/' />

        <div className={css.breadcrumbs}>
          <Link to='/' className={css.link}>
            Головна
          </Link>
          <span>{'>'}</span>
          <span className={css.link}>Згода на обробку персональних даних та положення про конфіденційність</span>
        </div>
      </div>

      <article>
        <h1>Згода на обробку персональних даних та положення про конфіденційність</h1>
        <p>
          Відповідно до статті 11 Закону України «Про захист персональних даних» надаю згоду на обробку та використання
          моїх персональних даних для здійснення повноважень, пов’язаних із розглядом цього звернення.
        </p>
        <br />

        <p>
          Ознайомлений(а) із забороною зазначення у зверненні інформації з обмеженим доступом, віднесеної до службової
          інформації чи державної таємниці. Зобов’язуюсь не зазначати у відомостях інформацію про місця ведення бойових
          дій із прив’язкою до координат, конкретних локацій у населених пунктах, дат, найменування підрозділів Сил
          оборони України та інших відомостей, які за сукупністю дають змогу встановити актуальні місця розміщення
          підрозділів Сил оборони України, чи локації виконання бойових завдань.
        </p>
        <br />

        <p>
          Ознайомлений(а) із змістом вимог Закону України «Про звернення громадян», зокрема, в наступній частині:
          <br /> * письмове звернення без зазначення місця проживання, не підписане автором (авторами), а також таке, з
          якого неможливо встановити авторство, визнається анонімним і розгляду не підлягає;
          <br /> * не розглядаються повторні звернення одним і тим же органом від одного і того ж громадянина з одного і
          того ж питання, якщо перше вирішено по суті, а також ті звернення, терміни розгляду яких передбачено статтею
          17 цього Закону, та звернення осіб, визнаних судом недієздатними;
          <br /> * не допускається розголошення одержаних із зі звернень відомостей про особисте життя громадян без їх
          згоди чи відомостей, що становлять державну або іншу таємницю, яка охороняється законом, та іншої інформації,
          якщо це ущемлює права і законні інтереси громадян;
          <br /> * не допускається з'ясування даних про особу громадянина, які не стосуються звернення;
          <br /> * на прохання громадянина, висловлене в усній формі або зазначене в тексті звернення, не підлягає
          розголошенню його прізвище, місце проживання та роботи.
        </p>
      </article>

      <div>
        <BackButton />
      </div>
    </main>
  );
}
